import eventsApi from 'api/requests/events';
import debounce from 'helpers/debounce';
import React, { useState, useEffect } from 'react'
import { Search, X } from 'lucide-react';
import styled from 'styled-components'
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import fonts from 'theme/fonts';
import SearchDropdown from './filters/SearchDropdown';
import { useContainerClick } from 'context/dash/ContainerClick';

export default function EventFilters({ hasEvents }) {
    const [nextEvents, setNextEvents] = useState(false)
    const [expiredEvents, setExpiredEvents] = useState(false)
    const [nowEvents, setNowEvents] = useState(false)
    const [draftEvents, setDraftEvents] = useState(false)
    const [isLoading, setIsloading] = useState(false)
    const [toogleDropdown, setToogleDropdown] = useState(false)
    const [inputValue, setInputValue] = useState('')

    const { containerClick } = useContainerClick()

    useEffect(() => {
        if (containerClick) {
            setToogleDropdown(false)
        }
    }, [containerClick])

    async function filter(searchTerm) {
        setToogleDropdown(true)
        setIsloading(true)

        if (!searchTerm) {
            setToogleDropdown(false)
        }

        try {
            const { data: res } = await eventsApi.searchEvents(searchTerm)
            setExpiredEvents(res?.data?.expired)
            setNextEvents(res?.data?.next)
            setNowEvents(res?.data?.now)
            setDraftEvents(res?.data?.draft)
        } catch (error) {
            console.log('error');
        } finally {
            setIsloading(false)
        }
    }

    const handleInput = debounce((searchTerm) => {
        searchTerm ? filter(searchTerm) : setToogleDropdown(false)
    }, 500)

    function onInputChange(e) {
        const value = e.target.value;
        setInputValue(value);
        handleInput(value);
    }

    function clearInput() {
        setInputValue('');
        setToogleDropdown(false);
    }

    return (
        hasEvents && (
            <SearchWrapper>
                <SearchIconWrapper>
                    <Search size={16} color={colors.night} />
                </SearchIconWrapper>

                <SearchInput
                    type="text"
                    placeholder="Buscar eventos..."
                    value={inputValue}
                    onChange={onInputChange}
                />

                {inputValue && (
                    <ClearButton onClick={clearInput} type="button" aria-label="Limpar busca">
                        <X size={14} color={colors.night} />
                    </ClearButton>
                )}

                {toogleDropdown && (
                    <SearchDropdown
                        closeDropdown={() => setToogleDropdown(false)}
                        isLoading={isLoading}
                        nextEvents={nextEvents}
                        expiredEvents={expiredEvents}
                        nowEvents={nowEvents}
                        draftEvents={draftEvents}
                    />
                )}
            </SearchWrapper>
        )
    )
}

const SearchWrapper = styled.div`
    position: relative;
    width: 100%;
    margin-bottom: 12px;

    @media screen and (min-width: ${breakpoints.md}) {
        width: 260px;
        margin-bottom: 0;
        margin-right: 12px;
    }
`;

const SearchIconWrapper = styled.div`
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    z-index: 1;
`;

const SearchInput = styled.input`
    width: 100%;
    height: 38px;
    padding: 0 36px 0 38px;
    border: 1px solid ${colors.neutralDark};
    border-radius: 10px;
    background: ${colors.neutralLight};
    font-size: ${fonts.sizes.default};
    color: ${colors.nightDark};
    outline: none;
    transition: all 0.2s ease;

    &::placeholder {
        color: ${colors.nightLight};
        font-size: 13px;
    }

    &:hover {
        border-color: ${colors.nightLight};
    }

    &:focus {
        border-color: ${colors.occasionalPurple};
        box-shadow: 0 0 0 3px ${colors.occasionalPurple}14;
    }
`;

const ClearButton = styled.button`
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: none;
    background: ${colors.neutralDark};
    cursor: pointer;
    transition: background 0.15s ease;
    z-index: 1;

    &:hover {
        background: ${colors.nightLight};

        & > svg {
            color: ${colors.neutralLight};
        }
    }
`;
